export default __webpack_public_path__ + "static/SOC-fa7f1c60057223034f7e61e0d6a0223b.png";